import React, { lazy, useEffect } from "react";
import { useSelector } from "react-redux";
import { getRoomOption } from "../../../base/conference";
import { translate } from "../../../base/i18n";

const DeviceContainer = lazy(() => import('../../../device/components/Device'));

function SettingPopup({
    t
}) {
    const roomName = useSelector(state => getRoomOption(state).name);
    
    useEffect(() => {
        return () => {
            APP.mateManagement.addDeviceListChange();
        }
    }, []);

    // get Device Track 
    const onclose = () => {        
        APP.UI.closeModal();
    }

    return ( 
        <div className="option_pop center" style={{width: "520px"}}>
            <div className="pop_head">
                <span className="title nonSelect"> { t("options.deviceSetting") } </span>
                <dl>
                    <span className="nonSelect" onClick={onclose}>
                        { t("dialog.close") } 
                    </span>
                </dl>
            </div>

            <div className={`pop_cotent`} style={{width: "100%",boxSizing: "border-box"}}>
                <DeviceContainer isRoom={true} roomName={roomName} />
            </div>
            
        </div>
        
    );
}
export default translate(SettingPopup);